<label mat-dialog-title class="uk-text-title title-assign">
    {{ title }}
</label>

<div class="container">
    <div class="row justify-content-md-center">
        <mat-form-field class="col-md-8">
            <mat-label>Buscar pickeador</mat-label>
            <input matInput (keyup)="applyFilter($event.target.value)" />
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
    </div>
</div>

<div class="container-table">
    <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="radioButton">
            <th mat-header-cell *cdkHeaderCellDef class="padding-radio"></th>
            <td mat-cell *matCellDef="let row; let i = index" class="padding-radio" [ngClass]="{'text-disabled':row?.activePicking}">
                <mat-radio-button class="radio-button" [value]="i.id" (change)="radioChange(row)" [disabled]="row?.activePicking"></mat-radio-button>                
            </td>
        </ng-container>
        <ng-container matColumnDef="pickerCode">
            <th mat-header-cell *matHeaderCellDef class="padding-column">Codigo de pickeador</th>
            <td mat-cell *matCellDef="let element; let i = index" class="padding-column" [ngClass]="{'text-disabled':element?.activePicking}">
                {{ element.code }}
            </td>
        </ng-container>
        <ng-container matColumnDef="pickerName">
            <th mat-header-cell *matHeaderCellDef [ngClass]="{'padding-column':!pickingSetting?.pickingFood}" >Nombre de pickeador</th>
            <td mat-cell *matCellDef="let element; let i = index" [ngClass]="{'text-disabled':element?.activePicking}">
                {{ element.firstName }} {{ element.lastName }}
            </td>
        </ng-container>
        <ng-container matColumnDef="information" *ngIf="pickingSetting?.pickingFood" class="sin-padding">
            <th mat-header-cell *cdkHeaderCellDef class="sin-padding"></th>
            <td mat-cell *matCellDef="let element; let i = index" class="p-2" [ngClass]="{'text-disabled':element?.activePicking}">
                <button mat-icon-button *ngIf="element?.activePicking" matTooltip="El pickeador está bloqueado porque tiene pedidos trabajando. Se habilitará nuevamente cuando finalice.">
                    <img src="./assets/icons-uikits/ico/information.svg" width="20px" />
                  </button>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
</div>
<mat-dialog-actions class="card-button" align="center">
    <button mat-stroked-button class="border-box b-s w-25" (click)="closeCancelDialog()">
        Cancelar
    </button>
    <button mat-dialog-close mat-flat-button (click)="onClickAccept()" [disabled]="!pickerSelected || buttonActive"
        class="button-primary-event w-25 button-success">
        {{ buttonToAccept }}
    </button>
</mat-dialog-actions>
<button mat-button mat-dialog-close class="dialog-close">
    <mat-icon>close</mat-icon>
</button>